import * as Yup from "yup";
import { Formik, Form } from "formik";
import { connect } from "react-redux";
import { BottomTag, BottomLinks } from "./styled";
import {
	LoginWrapper,
	LeftSection,
	RightSection,
	LoginSection,
} from "components/Login/styled";
import { Heading } from "../Heading";
import { TextInput } from "../FormInputs/TextInput";
import { Submit } from "../FormInputs/Submit";
import { guestSignup, guestLogin } from "../../actions/authActions";
import { OnSubmitValidationError } from "../../utils/OnSubmitValidationError";
import { Checkbox2 } from "../FormInputs/Checkbox2";
import { Link } from "@reach/router";
import { FlashError } from "../FormInputs/FlashError";
import { navigate } from "@reach/router";
import { LogoWrapper } from "../LogoWrapper/LogoWrapper";
import { showToast } from "utils/helpers";
import rightImg from "./../../icons/login-right-img.jpg";
import { CONTACT_US_URL } from "utils/constants";

const CustomLabel = () => {
	return (
		<p style={{ margin: "0px" }}>
			I agree to the{" "}
			<a
				href="/terms-and-conditions"
				target="_blank"
			>
				Terms & Conditions
			</a>{" "}
			and{" "}
			<a
				href="/privacy-policy"
				target="_blank"
			>
				Privacy Policy
			</a>
		</p>
	);
};

export const GuestAuthFormComponent = ({
	token,
	withRfqId,
	isSignUp,
	location,
	...props
}) => {
	const successMessage = (
		<>
			<h2>Login Successful</h2>
			<p>Welcome to Procuracon</p>
		</>
	);

	const emailFromStorage = localStorage.getItem("guest_signup_email") || "";
	const emailFromState = location?.state?.email || emailFromStorage;

	const sc = localStorage.getItem("ST");
	const rit = localStorage.getItem("RIT");

	const handleSubmit = async (values, setErrors, setSubmitting, setStatus) => {
		setSubmitting(true);
		setStatus(null);
		if (isSignUp) {
			try {
				await props.guestSignup(values, setSubmitting, setStatus);
				localStorage.setItem("guest_signup_email", values.email);
			} catch (e) {
				const error = e.response.data;
				setStatus(true);
				setErrors(error);
				error.errors !== undefined && setErrors(error);
			}
		} else {
			try {
				await props.guestLogin(values);
				setSubmitting(false);
				showToast(successMessage, "Success", true);
				localStorage.removeItem("guest_signup_email");
				const sharedToken = localStorage.getItem("ST");
				if (sharedToken) {
					navigate(`/share-profile?sc=${sharedToken}`);
				} else {
					navigate(`/account/request-for-quote`);
				}
			} catch (e) {
				setSubmitting(false);
				const error = await e.response.json();
				setStatus(true);
				setErrors(error);
				error.errors !== undefined && setErrors(error.message);
			}
		}
	};

	const hasGuestSignupEmail = !!localStorage.getItem("guest_signup_email");
	const userIdentifiedType = localStorage.getItem("user_identified_type");
	const hasExistingGuest = userIdentifiedType === "existing_guest";
	const token_type = rit
		? hasGuestSignupEmail || hasExistingGuest
			? "company"
			: "rfx"
		: "company";
	return (
		<LoginWrapper>
			<LeftSection>
				<LogoWrapper />

				<LoginSection>
					<Heading marginBottom="40px">
						<span className="welcome">
							{isSignUp
								? "Let’s Create your guest account and get you started."
								: "You already have a guest account."}
						</span>
						{!isSignUp && <span>Let’s sign you in.</span>}
					</Heading>

					<Formik
						enableReinitialize
						initialValues={{
							email: emailFromState,
							password: "",
							token_type: token_type,
							...(!(rit && (hasGuestSignupEmail || hasExistingGuest)) && {
								token: rit ?? sc,
							}),
							...(isSignUp && { agreed: false }),
						}}
						validationSchema={Yup.object({
							email: Yup.string().email().required(),
							password: Yup.string().required(),
							...(isSignUp && {
								agreed: Yup.boolean()
									.oneOf([true], "Please accept before continuing")
									.required("Please accept before continuing"),
							}),
						})}
						onSubmit={(values, { setErrors, setSubmitting, setStatus }) => {
							setStatus(false);
							const submissionValues = { ...values };
							if (!isSignUp) {
								delete submissionValues.agreed;
							}
							handleSubmit(
								submissionValues,
								setErrors,
								setSubmitting,
								setStatus
							);
						}}
					>
						{(props) => {
							const { setFieldValue, isSubmitting, status, setStatus, errors } =
								props;
							const onSubmitValidationError = () => {
								setStatus("required");
							};

							return (
								<Form onChange={() => setStatus(false)}>
									<div className="row">
										<TextInput
											label="Enter your email"
											placeholder="Email"
											name="email"
											type="email"
											className="col xl-12"
											data-testid="guest-email"
											setFieldValue={setFieldValue}
										/>

										<TextInput
											label="Enter your password"
											placeholder="Password"
											name="password"
											type="password"
											className="col xl-12"
											data-testid="guest-password"
											setFieldValue={setFieldValue}
											icon
										/>
										{!isSignUp ? (
											<BottomLinks className="col xl-12">
												<Checkbox2
													label="Remember me"
													name="remember me"
												/>
												<Link to="/guest/reset-password">
													Forgot my password
												</Link>
											</BottomLinks>
										) : (
											<>
												<BottomLinks className="col xl-12">
													<Checkbox2
														name="agreed"
														labelComponent={<CustomLabel />}
														data-testid="guest-agreed"
														noWarning
													/>
												</BottomLinks>
											</>
										)}
										<div className="col xl-12">
											{status && (
												<FlashError
													heading={errors?.title || errors?.error}
													text={
														errors.agreed ||
														errors?.error ||
														errors?.errors?.error ||
														errors?.errors?.token ||
														errors?.errors?.email ||
														errors?.errors?.password
													}
													margin="20px 0px 0px 0px"
												/>
											)}
										</div>
										<div className="col xl-12">
											<Submit
												type="submit"
												widthExpand
												marginTop={"24px"}
												isSubmitting={isSubmitting}
												text={isSignUp ? "sign up" : "sign in"}
												submittingText={
													isSignUp ? "Signing up..." : "Logging in..."
												}
												data-testid={"sign-in-up-button"}
											/>
										</div>
									</div>
									<OnSubmitValidationError callback={onSubmitValidationError} />
								</Form>
							);
						}}
					</Formik>
					<BottomTag>
						{isSignUp ? (
							<>
								Already have an account?
								<br />
								<div className="flex justify-between gap-8">
									<Link
										to={"/guest/login"}
										data-testid={"guest-login"}
									>
										Sign In as a Guest
									</Link>
									<Link
										to={`/member/login`}
										data-testid={"subscriber-login"}
									>
										Sign In as a Subscriber
									</Link>
								</div>
							</>
						) : (
							<>
								Not Signed Up yet?{" "}
								<a
									href={CONTACT_US_URL}
									target="_blank"
									rel="noopener noreferrer"
								>
									Contact Us to Join
								</a>
							</>
						)}
					</BottomTag>
				</LoginSection>
			</LeftSection>
			<RightSection style={{ backgroundImage: `url(${rightImg})` }} />
		</LoginWrapper>
	);
};

export const GuestAuthForm = connect(null, {
	guestLogin,
	guestSignup,
})(GuestAuthFormComponent);
